<nz-select nzAllowClear nzShowSearch nzServerSearch [nzPlaceHolder]="placeholder" 
	[nzLoading]="loading || searchLoading || scrollLoading"
	[nzDropdownRender]="renderTemplate"
	[nzMode]="mode"
	[nzMaxTagCount]="1"
	[disabled]="disabled"
	[(ngModel)]="selectedAccount"
	(nzOnSearch)="search($event)"
	(nzScrollToBottom)="scrollToBottom()"
	(ngModelChange)="accountChange()"
>
	<ng-container *ngFor="let account of accounts">
		<nz-option nzCustomContent
			[nzValue]="account?.uuid" 
			[nzLabel]="account?.fName"
			*ngIf="!loading && !searchLoading"
		><span [class.text-danger]="account?.fDeleted == 1">{{ account?.fName }}</span></nz-option>
	</ng-container>
	<nz-option *ngIf="loading || searchLoading" nzDisabled nzCustomContent>
		<span nz-icon nzType="loading"></span>
		Loading Data...
	</nz-option>
</nz-select>
<ng-template #renderTemplate>
	<nz-spin *ngIf="scrollLoading"></nz-spin>
</ng-template>